export const mail = 'info@homeforstudents.it'
export const phone = '+39 375 628 7429'
// Same number as `phone`, in the digits-only international format wa.me links expect
export const whatsappNumber = '393756287429'
export const mailInvest = 'homeforstudents@gmail.com'
export const phoneInvest = '+39 327 547 7028'
